{
  "eyebrow": "Tarif bestätigen",
  "title": "Prüfen & konfigurieren.",
  "sub": "Abrechnungszyklus oder Tarif können Sie jederzeit über Ihr Admin-Dashboard ändern.",
  "yourPlan": "Ihr Tarif",
  "changePlan": "Tarif ändern",
  "billing": "Abrechnungszyklus",
  "billingMonthLabel": "Monatlich zahlen",
  "billingMonthDesc": "Flexibel. Jederzeit kündbar.",
  "billingYearLabel": "Jährlich zahlen",
  "billingYearDesc": "~17% Rabatt. Einmal jährlich abgerechnet.",
  "addons": "Zusatzmodule",
  "addon": {
    "ssec": "Sozialversicherung (Check-in/out@work)",
    "ssecDesc": "Nur Belgien — automatische Dimona-Meldung.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "Live-GPS für Firmenfahrzeuge. +4 €/Fahrzeug/Monat.",
    "vehicles": "Fahrzeuge",
    "projectAddon": "Projektmanagement-Add-on",
    "projectAddonDesc": "Schaltet die Projektmanagement-Funktionen von Time Pro frei (Zusatzarbeit, Schichtplanung, Subunternehmer-Verwaltung)."
  },
  "employees": {
    "title": "Wie viele Mitarbeitende?",
    "active": "aktive Nutzer",
    "popular": "Die meisten Teams wählen {{n}}"
  },
  "estimate": "Geschätzte monatliche Kosten",
  "estimateNote": "Ohne MwSt. Nutzergebühren werden nach aktiven Mitarbeitenden abgerechnet.",
  "estimateUnavailable": "Preiskatalog nicht verfügbar. Erneut versuchen, um die aktuellen Preise zu laden."
}
